var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","color":"primary"}},[(_vm.showLayerControl)?_c('v-btn',{attrs:{"icon":"","color":"white","id":"footer-layercontrol-btn"}},[_c('v-icon',[_vm._v("mdi-layers")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }